import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { GaugePage } from './gauge';

@NgModule({
  declarations: [
    GaugePage,
  ],
  imports: [
    IonicPageModule.forChild(GaugePage),
  ],
  exports: [
    GaugePage
  ]
})
export class GaugePageModule {}



// WEBPACK FOOTER //
// ./src/pages/gauge/gauge.module.ts